import type { IdName } from '@/js/account/entities/document/model/types';
import { onMounted, ref } from 'vue';
import {
  accountDocumentCategoriesIndex,
  accountDocumentTagsIndex,
} from '@/js/account/entities/document/api';

const categories = ref<IdName[]>([]);
const tags = ref<IdName[]>([]);
const loading = ref(false);
let loaded = false;
let loadPromise: Promise<void> | null = null;

async function loadOptions(): Promise<void> {
  if (loaded) {
    return;
  }

  if (loadPromise) {
    await loadPromise;
    return;
  }

  loading.value = true;

  loadPromise = (async () => {
    try {
      [categories.value, tags.value] = await Promise.all([
        accountDocumentCategoriesIndex(),
        accountDocumentTagsIndex(),
      ]);
      loaded = true;
    }
    finally {
      loading.value = false;
      loadPromise = null;
    }
  })();

  await loadPromise;
}

export function useLibraryFilterOptions(): {
  categories: typeof categories
  tags: typeof tags
  loading: typeof loading
} {
  onMounted(() => {
    void loadOptions();
  });

  return { categories, tags, loading };
}
